import React from 'react'
import {Helmet} from 'react-helmet'

interface StructuredDataProps {
    data: object
}

export function StructuredData(props: StructuredDataProps): React.JSX.Element {
    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(props.data)}
                </script>
            </Helmet>
        </>
    )
}
